module.exports = __webpack_public_path__ + "static/img/menuPowieksz-OFF.f1a3bdc8.png";